var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center pt-2"},[_c('v-pagination',{attrs:{"length":_vm.totalPages,"total-visible":10},on:{"input":_vm.pageChanged},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }